import React from 'react'
import Typed from 'react-typed'
import Footer from './Footer'
import Navbar from './Navbar'

const FAQ = () => {
  return (
    <div className='text-white'>
    <Navbar />
    <div className='flex justify-center items-center'>

      <Typed className='md:text-5xl sm:text-6xl text-xl font-bold pl-2 text-center' strings={['FAQs']} typeSpeed={50} backSpeed={75} />
    
    </div>
    <div className='flex-col justify-center items-center'>
      <div className='w-15 shadow-xl flex flex-col p-4 mt-10 rounded-lg hover:scale-105 duration-150 bg-white mx-10'>

                    
<h1 className='text-3xl font-bold text-center  text-black'>Q: What kind of organization is Theta Tau Alpha?</h1>
<h2 className='text-black  mt-2'>A: Theta Tau is a professional engineering fraternity. The purpose of Theta Tau is to develop and maintain a high standard of professional interest among its members, and to unite them in a strong bond of fraternal fellowship. We separate ourselves from being a social fraternity because we emphasize professionalism as a common goal. Nonetheless, we hold many social events, such as intramural sports, camping, and fraternity potluck dinners, all of which foster brotherhood.</h2>


</div>



<div className='w-15 shadow-xl flex flex-col p-4 mt-10 rounded-lg hover:scale-105 duration-150 bg-white mx-10'>

                    
<h1 className='text-3xl font-bold text-center  text-black'>Q: Is Theta Tau Alpha Co-Ed</h1>
<h2 className='text-black text-center'>A:Yes. Theta Tau Alpha is a Co-ed Fraternity.</h2>


</div>




<div className='w-15 shadow-xl flex flex-col p-4 mt-10 rounded-lg hover:scale-105 duration-150 bg-white mx-10'>

                    
<h2 className='text-3xl font-bold text-center  text-black'>Q: What are the requirements?</h2>
<p className='text-black text-center mt-2'>

  A: Here are the list of requirements every rushee/pledge needs to meet:

  <ul className='mt-2'>
    <li>- Must be at least 18 years of age at the time of initiation</li>
    <li>- Overall GPA 3.0 (Freshman - good academic standing)</li>
    <li>- Must not be an active member of a competing fraternity</li>
    <li>- Most importantly, must show good character</li>
  </ul>


</p>


</div>


<div className='w-15 shadow-xl flex flex-col p-4 mt-10 rounded-lg hover:scale-105 duration-150 bg-white mx-10'>

                    
<h1 className='text-3xl font-bold text-center  text-black'>Q: Why should I consider Theta Tau Alpha?</h1>
<h2 className='text-black text-center'>A: What makes Theta Tau Alpha great is the development of its members. The area between social fraternity and honor society allows us to create an environment where students can grow academically, professionally, and socially. Professionalism is paramount, yet at the same time we don’t forget about the fundamental, social aspect of brotherhood; we ultimately help each other become well-rounded men and women. Theta Tau Alpha is a strong professional and social network that will last for life.</h2>


</div>

<div className='w-15 shadow-xl flex flex-col p-4 mt-10 rounded-lg hover:scale-105 duration-150 bg-white mx-10'>

                    
<h1 className='text-3xl font-bold text-center  text-black'>Q: What is “Rushing”?</h1>
<h2 className='text-black text-center'>A: “Rushing” is an open invitation for eligible students to learn about becoming a member of Theta Tau Alpha. Rush is usually held during the first few weeks of the fall and spring semesters. During this time you will see signs posted saying “Rush Theta Tau Alpha.” Theta Tau Alpha holds Rush events where we give out pizza, go bowling, BBQ, play sports among other activities. During this time, you first meet the members of Theta Tau and they get to meet you. The purpose is to let the brothers of Theta Tau Alpha know you are interested in joining. You also learn about the fraternity and the upcoming pledge process so you can make an informed decision about joining. During the two rush weeks, you are encouraged to come to as many rush events as possible. You should introduce yourself to the members and ask any questions they may have about Theta Tau Alpha. At the end of the rush period, the members of Theta Tau Alpha choose who will receive a bid to continue on to the pledge process.</h2>


</div>


<div className='w-15 shadow-xl flex flex-col p-4 mt-10 rounded-lg hover:scale-105 duration-150 bg-white mx-10'>

                    
<h1 className='text-3xl font-bold text-center  text-black'>Q: What is a “bid” and how do I receive one?</h1>
<h2 className='text-black text-center'>A: A “bid” is a formal invitation to pledge a fraternity. Bids are given out to rushees who have shown potential of being a good member of Theta Tau. To receive a bid, come out to the rush events. Get to know the current members, as the chances of receiving a bid increase by doing so. Immediately after the rush events, be sure to submit the “Interview Sign-Up” form on our website. After the interviews, the members will hold a meeting to determine which rushees may move on to the pledging process. If the members decide to allow the rushee to continue to the pledging process, that rushee will receive a bid.</h2>


</div>


<div className='w-15 shadow-xl flex flex-col p-4 mt-10 rounded-lg hover:scale-105 duration-150 bg-white mx-10'>

                    
<h1 className='text-3xl font-bold text-center  text-black'>Q: Are there any requirements to be initiated into Theta Tau?</h1>
<h2 className='text-black text-center'> A: Here are the list of requirements every rushee/pledge needs to meet:

<ul className='mt-2'>
  <li>- Attend the weekly pledge sessions</li>
  <li>- Pay the pledge fee on time (please see the question about fees below)</li>
  <li>- Complete a pledge project (the Pledge Marshal will let you know more about it later)</li>
  <li>- Pass the Chapter Tests</li>
  <li>- Attend initiation</li>
</ul></h2>


</div>

<div className='w-15 shadow-xl flex flex-col p-4 mt-10 rounded-lg hover:scale-105 duration-150 bg-white mx-10'>

                    
<h1 className='text-3xl font-bold text-center  text-black'>Q: What if I cannot make it to events due to conflicts?</h1>
<h2 className='text-black text-center'>A: Pledges and members are highly encouraged to attend their respective meetings and activities. However, school comes first. As we are all students, we recognize the importance of having time to study. If a class or review conflicts with a meeting or activity, academics have top priority. If you know you are going to absent, pledges should contact the Pledge Marshal; members should contact the Scribe.</h2>


</div>


<div className='w-15 shadow-xl flex flex-col p-4 mt-10 rounded-lg hover:scale-105 duration-150 bg-white mx-10'>

                    
<h1 className='text-3xl font-bold text-center  text-black'>Q: May I still join Theta Tau if I am already in another fraternity/sorority?</h1>
<h2 className='text-black text-center'>A: Yes, as long as you are not in any competitive professional fraternities you are welcome to rush!</h2>


</div>

<div className='w-15 shadow-xl flex flex-col p-4 mt-10 rounded-lg hover:scale-105 duration-150 bg-white mx-10'>

                    
<h1 className='text-3xl font-bold text-center  text-black'>Q: I have more questions!</h1>
<h2 className='text-black text-center'>A: We have more answers! If you have any other questions, please contact the Rush Chair or the Pledge Marshal. Either one of them will be happy to answer them for you. If they are not available, then reach us out on our socials, we would be happy to help you there!</h2>


</div>
      </div>
    <Footer />
  </div>
  )
}

export default FAQ